import React from 'react';

import Accordion from '../../Accordion';

import styles from './FAQs.module.scss';

function FAQsSection({ items }) {
  const [haveExpanded, setHaveExpanded] = React.useState(false);

  const handleViewMore = () => {
    setHaveExpanded((prev) => !prev);
  };

  return (
    <div className={styles.wrapper}>
      {items.slice(0, haveExpanded ? items.length : 6).map((item) => (
        <Accordion
          key={item.faq_question}
          title={item.faq_question}
          options={{
            accordionClass: styles.accordion,
            accordionHeaderClass: styles.accordionHeader,
            accordionHeaderTitleClass: styles.accordionHeaderTitle,
            accordionHeaderIconClass: styles.accordionHeaderIcon,
            accordionContentWrapperClass: styles.accordionContentWrapper,
            accordionContentClass: styles.accordionContent,
            iconAngle: 270,
            iconOnOpenAngle: 0,
          }}
        >
          <p>{item.faq_answer}</p>
        </Accordion>
      ))}

      {items.length > 6 && !haveExpanded && (
        <div
          className={styles.viewAllWrapper}
          onClick={handleViewMore}
        >
          <span>View All</span>
        </div>
      )}
    </div>
  );
}

export default FAQsSection;
